import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const getInviteFromEmailQuery = gql`
  query getInviteFromEmailQuery($email: EmailAddress!) {
    inviteFromEmail(email: $email)
  }
`;

export function useInviteFromEmail(email?: string) {
  const { data, loading, error } = useQuery(getInviteFromEmailQuery, {
    variables: { email },
    fetchPolicy: 'no-cache',
    skip: !email,
  });

  return {
    inviteId: data?.inviteFromEmail,
    loading,
    error,
  };
}
